import { render, staticRenderFns } from "./DesktopFooter.vue?vue&type=template&id=6c799c56&"
import script from "./DesktopFooter.vue?vue&type=script&lang=js&"
export * from "./DesktopFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports